import type { SelectColor } from '@/lib/databases/values';
import { createElement } from 'react';

export function SelectChip({
  label,
  color,
  onRemove,
}: {
  label: string;
  color?: SelectColor | null;
  onRemove?: () => void;
}) {
  const colorClass = color ? `cs-db-select-chip-${color}` : 'cs-db-select-chip-gray';
  return createElement(
    'span',
    { className: `cs-db-select-chip ${colorClass}`, title: label },
    createElement('span', { className: 'cs-db-select-chip-label' }, label),
    onRemove
      ? createElement(
          'button',
          {
            type: 'button',
            className: 'cs-db-select-chip-remove',
            'aria-label': `Remove ${label}`,
            onClick: (e: MouseEvent) => {
              e.stopPropagation();
              onRemove();
            },
            onMouseDown: (e: MouseEvent) => e.stopPropagation(),
          },
          '×',
        )
      : null,
  );
}
